export const updateFinishOrder = order => ({
  type: 'UPDATE_FINISH_ORDER',
  payload: order,
});

export const pushBeforeFinishOrder = (order) => ({
  type: "PUSH_BEFORE_FINISH_ORDER",
  payload: order,
});
